__turbopack_context__.v({
  "accessTabContent": "styles-module-scss-module__TWwrBW__accessTabContent",
  "block": "styles-module-scss-module__TWwrBW__block",
  "categoryTabContent": "styles-module-scss-module__TWwrBW__categoryTabContent",
  "completed": "styles-module-scss-module__TWwrBW__completed",
  "content": "styles-module-scss-module__TWwrBW__content",
  "form": "styles-module-scss-module__TWwrBW__form",
  "header": "styles-module-scss-module__TWwrBW__header",
  "hero": "styles-module-scss-module__TWwrBW__hero",
  "inProgress": "styles-module-scss-module__TWwrBW__inProgress",
  "levelText": "styles-module-scss-module__TWwrBW__levelText",
  "logo": "styles-module-scss-module__TWwrBW__logo",
  "logoPlaceholder": "styles-module-scss-module__TWwrBW__logoPlaceholder",
  "notStarted": "styles-module-scss-module__TWwrBW__notStarted",
  "overviewLevel": "styles-module-scss-module__TWwrBW__overviewLevel",
  "overviewTabContent": "styles-module-scss-module__TWwrBW__overviewTabContent",
  "overviewTabContentBody": "styles-module-scss-module__TWwrBW__overviewTabContentBody",
  "overviewTabContentHead": "styles-module-scss-module__TWwrBW__overviewTabContentHead",
  "tabContent": "styles-module-scss-module__TWwrBW__tabContent",
  "tabs": "styles-module-scss-module__TWwrBW__tabs",
});
